module.exports = __webpack_public_path__ + "static/media/app-store-badge-white.9a3b29da.png";